import { render } from "./UserBalance.vue?vue&type=template&id=f3b65db2"
import script from "./UserBalance.vue?vue&type=script&lang=js"
export * from "./UserBalance.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Microsoft VS Code Project\\startkit\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__